export const sourceIcons: Record<string, any> = {
  'wttj': require('@/assets/logo/wttj_logo.png'),
  'kaspr': require('@/assets/logo/kaspr_logo.png'),
  'linkedin': require('@/assets/logo/linkedin.png'),
  'whatsapp': require('@/assets/logo/whatsapp.png'),
  'website': require('@/assets/logo/website.png'),
  'vinci-jobs': require('@/assets/logo/website.png'),
  'vinci-mobility': require('@/assets/logo/website.png'),
}
